import { getVariantLabel } from "@leafly-com/web-utils";

import fullVariantSizeText from "common/fullVariantSizeText";
import { centsToDollars } from "common/currencyFormatter";

export function finalPrice(variant: any, quantity: number): number {
  return variant.deal?.active
    ? (centsToDollars(variant.deal.discountedPrice * quantity) as number)
    : variant.price * quantity;
}

/**
 * Outputs e.g.: "1 item @ 4g each", unless the quantity is "each", in which
 * case it will output only "1 item".
 */
export function quantityLabel(variant: any, quantity: number): string {
  const itemCount = `${quantity} item${quantity === 1 ? "" : "s"}`;
  const size = fullVariantSizeText(
    getVariantLabel({
      packageUnit: variant.unit,
      packageSize: variant.quantity,
    })
  );

  if (size && size !== "each") {
    return `${itemCount} @ ${size} each`;
  } else {
    return itemCount;
  }
}
